import React from 'react';
import Spinner from "react-bootstrap/Spinner";
const LoadingTable = () => {
  return (
    <div className="text-center mb-3">
    <hr />
    <b style={{ color: "#767676", fontSize: "20px" }}>
      <Spinner
        as="span"
        animation="border"
        variant="#767676"
        size="sm"
        role="status"
        aria-hidden="true"
      />
      กรุณารอสักครู่...
    </b>
    <hr />
  </div>
  );
};

export default LoadingTable;
